//source: https://github.com/dominicarrojado/react-typescript-accordion
import {ReactNode, useState} from "react";
import AccordionItem from "./AccordionItem";

interface AccordionData {
    title: string;
    content?: ReactNode;
    hiddenContent?: ()=>ReactNode;
    tabLink?: string
    customCont?: string
    titleFont?:string
}

function Accordion({
                       items,
                       className = "",
                       headerClassName = "",
                       hasHtml = false,
                       tabLink = null,
                       gtm = null,
customCont=""                   }: {
    items: Array<AccordionData>;
    className?: string;
    headerClassName?: string;
    hasHtml?: boolean;
    tabLink?: string;
    gtm?: () => void;
    customCont?: string;
}) {
    const [currentIdx, setCurrentIdx] = useState(-1);
    const btnOnClick = (index: number) => {
        setCurrentIdx((currentValue) => (currentValue !== index ? index : -1));
    };
    return (
        <>
            {items.map((item, index) => (
                <AccordionItem
                    customCont={customCont}
                    tabLink={tabLink || item.tabLink}
                    headerClassName={headerClassName}
                    className={className}
                    key={index}
                    data={item}
                    isOpen={index === currentIdx}
                    btnOnClick={() => btnOnClick(index)}
                    hasHtml={hasHtml}
                    gtm={gtm}
                />
            ))}
        </>
    );
}

export default Accordion;
